<template>
  <div class="g-bd">
    <div class="login-bg"></div>
    <img class="login-ch" src="/images/ch.png" alt="" />
    <!-- 登录模块 -->
    <div class="m-login-box">
      <div class="login-title login-mar">
        <div>
          <h3>找回密码</h3>
        </div>
        <div>
          <span>记得密码？</span>
          <a href="/login">&nbsp;直接登录</a>
        </div>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="0">
        <el-form-item label prop="mobile">
          <div class>
            <el-input
              prefix-icon="el-icon-mobile-phone"
              v-model.trim="form.mobile"
              placeholder="请输入注册手机号"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="code">
          <div class="login-code">
            <div style="padding-right: 20px">
              <el-input
                v-model.trim="form.code"
                placeholder="请输入短信验证码"
              ></el-input>
            </div>
            <el-button
              :type="mobleLoading ? 'info' : 'primary'"
              @click="getMobleCode"
              :disabled="mobleLoading"
              >{{
                mobleLoading == false
                  ? "获取短信验证码"
                  : `${countNum}秒后重新获取`
              }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label prop="newPassword">
          <div class>
            <el-input
              prefix-icon="el-icon-lock"
              v-model.trim="form.newPassword"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label prop="rePassword">
          <div class>
            <el-input
              prefix-icon="el-icon-lock"
              v-model.trim="form.rePassword"
              show-password
              placeholder="确认新密码"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-btn login-mar">
        <el-button
          type="primary"
          size
          @click="getPass"
          @keyup.enter.native="onKeydown"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// 语义化参数
import Qs from "qs";
// 密码加密
import md5 from "js-md5";
import { mapGetters } from "vuex";

export default {
  data() {
    let pattern1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,16}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!pattern1.test(value)) {
          callback(new Error("请输入6-16位且包含数字，大小写字母三种"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        code: "",
        mobile: "",
        newPassword: "",
      },
      btnLoading: false,
      mobleLoading: false,
      baseImg: "",
      countNum: 60,
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // {
          //   pattern: /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9])[0-9]{8}$/,
          //   message: "请输入正确的手机号",
          //   trigger: "blur"
          // }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        rePassword: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur",
          },
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
    };
  },

  mounted() {},
  // 监听表单内容
  watch: {},
  methods: {
    getMobleCode() {
      if (
        /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9])[0-9]{8}$/.test(
          this.form.mobile
        ) != true
      ) {
        this.$message({
          message: "请先输入正确手机号码",
          type: "warning",
        });
        return;
      }
      let par = {
        phone: this.form.mobile,
        type: 2,
      };
      this.$http
        .post("/api/static/getMessageCode", par)
        .then((res) => {
          this.mobleLoading = true;
          this.intervalBtn = setInterval(() => {
            if (this.countNum <= 0) {
              // 重置btn提示信息
              this.mobleLoading = false;
              // 清除定时器
              clearInterval(this.intervalBtn);
              // 更改btn状态
              this.countNum = 60;
            }
            // 倒计时
            this.countNum--;
          }, 1000);
        })
        .catch((msg) => {
          // console.log(msg);
        });
    },
    onKeydown(e) {
      // console.log(e);
      if (e.keyCode == 13) {
        this.getPass();
      }
    },
    // 重置密码
    getPass() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let par = this.form;
          this.$http
            .post("/api/web/register/findPass", par)
            .then((res) => {
              this.$message({
                message: "重置成功",
                type: "success",
              });
              setTimeout(function () {
                this.$router.push({
                  path: "/login",
                });
              }, 1000);
            })
            .catch((msg) => {
              this.$message.error(msg);
            });
        }
      });
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.g-bd {
  padding: 200px 0 60px;
  background: #f7f8f9;
  overflow: hidden;
  .login-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(/images/bg1.png) center no-repeat;
    background-size: cover;
  }
}
.m-login-box {
  position: relative;
  width: 450px;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  margin: 0 0 0 55%;
  .el-form-item {
    margin-bottom: 25px;
  }
  .login-title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h3 {
      font-size: 30px;
      color: #333;
    }

    span {
      font-size: 14px;
      color: #777;
    }
    a {
      cursor: pointer;
      font-size: 14px;
      color: #3685fd;
    }
  }
  .login-mar {
    margin-bottom: 30px;
  }
  .login-code {
    display: flex;
    div {
      flex: 1;
    }
    .code-img {
      width: 140px;
      max-width: 140px;
      cursor: pointer;
      img {
        vertical-align: top;
      }
    }
  }
  .login-btn {
    margin: 30px 0 20px;
    .el-button {
      width: 100%;
      font-size: 16px;
    }
  }
}
</style>
